const BACKEND_URL = "http://localhost:4000";
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? BACKEND_URL;
